import { render } from "./ContactusView.vue?vue&type=template&id=57967aa2"
import script from "./ContactusView.vue?vue&type=script&lang=js"
export * from "./ContactusView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__